"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
// @ts-ignore
import "swiper/css";
// @ts-ignore
import "swiper/css/bundle";
import { motion } from "framer-motion";
import Image from "next/image";

const images = [
  {
    src: "/pictures/top1.jpg",
    text: "Beautiful structure",
  },
  {
    src: "/pictures/top2.jpg",
    text: "Ready for the Singapore Grand Prix!",
  },
  {
    src: "/pictures/top3.jpg",
    text: "@rokaf.blackeagles a treat to watch!",
  },
  {
    src: "/pictures/top4.jpg",
    text: "Guess where?",
  },
  {
    src: "/pictures/top5.jpg",
    text: "Speed ⚡️",
  },
  {
    src: "/pictures/top6.jpg",
    text: "Passing out parade!",
  },
  {
    src: "/pictures/top7.jpg",
    text: "Capturing every moment possible 🎆",
  },
  {
    src: "/pictures/top8.jpg",
    text: "Face off 👀",
  },
  {
    src: "/pictures/top9.jpg",
    text: "Boxing",
  },
  {
    src: "/pictures/top10.jpg",
    text: "Analyzing",
  },
];

export default function ImageCarousel() {
  return (
    <div className="relative w-full max-w-4xl mx-auto mb-40">
      <section className="items-center">
        <motion.h3
          initial={{ y: 48, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ ease: "easeInOut", duration: 0.75 }}
          className="mb-5 text-2xl font-black uppercase text-zinc-50 text-center"
        >
          My Top 10!
        </motion.h3>
      </section>
      <div className="overflow-hidden">
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={0}
          slidesPerView={1}
          centeredSlides={true}
          navigation={{
            prevEl: ".swiper-button-prev",
            nextEl: ".swiper-button-next",
          }}
          pagination={{ clickable: true }}
          className="w-full"
        >
          {images.map((item, index) => (
            <SwiperSlide key={index} className="pb-10">
              <div className="rounded-lg overflow-hidden">
                <img
                  src={item.src}
                  alt={item.text}
                  className="w-full rounded-lg object-cover"
                />
              </div>
              <p className="mt-3 text-center text-sm text-zinc-400 italic">
                {item.text}
              </p>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Navigation Arrows (Bottom right) */}
      <div className="absolute right-4 flex gap-4">
        <button className="swiper-button-prev !w-8 !h-8 flex items-center justify-center mx-5 text-white"></button>
        <button className="swiper-button-next !w-8 !h-8 flex items-center justify-center mx-5 text-white"></button>
      </div>
    </div>
  );
}
